/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { RejectWithdrawalOptions, RejectWithdrawalResponses } from '../types/RejectWithdrawal'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Rejects a withdrawal that no fee has been locked against, transitioning it to REJECTED and releasing its reservation: the reserved quantity+fee is credited back to the user's available balance. Nothing is sent on-chain. The supplied reason is recorded as the withdrawal's failure_reason.
 * Both `PENDING` and `APPROVED_WITHOUT_FEE` withdrawals may be rejected — an approval that has not been paid for is still reversible. A rejected withdrawal keeps its approved_by/approved_at if it had them. `APPROVED` and `BROADCAST` withdrawals may not: a locked fee means the withdrawal is queued for submission, so those are refused with 409 and can only end in FAILED. A reservation can never be released twice.
 * @summary Reject a USDC withdrawal that has no fee locked (admin)
 * {@link /v1/web3/admin/withdrawals/:withdrawal_id/reject}
 */
export function rejectWithdrawal<ThrowOnError extends boolean = true>(
  options: Options<RejectWithdrawalOptions, ThrowOnError>,
): Unwrappable<RequestResult<RejectWithdrawalResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/web3/admin/withdrawals/{withdrawal_id}/reject',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RejectWithdrawalResponses, ThrowOnError>>,
  )
}
